import * as React from 'react';
import createCtx, { InnerContext } from '@narvar/nth-hook-context';
import {
  RequestDeliveryInstructionsAddressVerificationFields,
  ResponseDeliveryInstructionsLeaveAtOptions,
} from '../../server/api/schema';

export enum UI_STATE {
  INITIAL,
  ADDRESS_VERIFICATION,
  DELIVERY_INSTRUCTIONS,
  SUBMIT_SUCCESS,
  NARVAR_OPTIN_SUBMIT_SUCCESS,
  NARVAR_APPLIED_SUBMIT_SUCCESS,
}

interface DeliveryInstructionsContext {
  deliveryInstructionsUIState: UI_STATE;
  stepNavigationChange?: boolean;
  verifiedAddress?: RequestDeliveryInstructionsAddressVerificationFields;
  leaveAtOptions?: ResponseDeliveryInstructionsLeaveAtOptions[];
  leaveAtValue?: string;
  registerAccount?: boolean;
  visible?: boolean;
  asrSignatureRequired?: boolean;
  narvarSubmitted?: boolean;
  hasProfile?: boolean;
}

export const DEFAULT_DELIVERY_INSTRUCTIONS_CONTEXT: DeliveryInstructionsContext =
  {
    deliveryInstructionsUIState: UI_STATE.INITIAL,
    stepNavigationChange: false,
    verifiedAddress: undefined,
    leaveAtOptions: undefined,
    leaveAtValue: undefined,
    registerAccount: false,
    visible: true,
    asrSignatureRequired: false,
    narvarSubmitted: false,
  };

const [DeliveryInstructionsContext, DeliveryInstructionsProvider] = createCtx(
  DEFAULT_DELIVERY_INSTRUCTIONS_CONTEXT,
);

export { DeliveryInstructionsProvider };

export const useDeliveryInstructionsContext =
  (): InnerContext<DeliveryInstructionsContext> => {
    const { state, update: reduceUpdate } = React.useContext(
      DeliveryInstructionsContext,
    );

    return {
      state,
      update: (newState): void => {
        reduceUpdate({
          ...state,
          ...newState,
        });
      },
    };
  };
